import React from 'react'
import ReactDOM from 'react-dom'
import './styles/site.scss'
import App from './App/App'

ReactDOM.render(<App />, document.getElementById('root'))
